export const handleImmixDrawIgnoreZonesInput = (
  camerasObject: any,
  setCamerasObject: any,
  checked: boolean
) => {
  // Update localStorage first so AutoAddTable doesn't overwrite our changes
  const immixAlertPostObject = JSON.parse(
    localStorage.immixAlertPostObject || "{}"
  );
  immixAlertPostObject.draw_ignore_zones = checked;
  localStorage.setItem(
    "immixAlertPostObject",
    JSON.stringify(immixAlertPostObject)
  );

  // Create a deep copy of the camerasObject to ensure React detects the change
  const newCamerasObject = { ...camerasObject };

  for (const key in camerasObject) {
    newCamerasObject[key] = {
      ...camerasObject[key],
      immix: {
        ...camerasObject[key].immix,
      },
    };
    newCamerasObject[key].immix.draw_ignore_zones = checked;
  }

  setCamerasObject(newCamerasObject);
};
